import type { TypeElements } from '../../types/element';

import appendChildAtIndex from './appendChildAtIndex';
import appendChildren from './appendChildren';

// ----------------------------------------------------------------------------

declare global {
    interface Node {
        appendChildAtIndex(element: Node, index: number): Node;
        appendChildren(elements: TypeElements): Node;
    }
}

// ----------------------------------------------------------------------------

Node.prototype.appendChildAtIndex = function (element: Node, index: number): Node {
    appendChildAtIndex(this, element, index);

    return this;
};

Node.prototype.appendChildren = function (elements: TypeElements): Node {
    appendChildren(this, elements);

    return this;
};
